import { isOrderRestatement, isUserNotification } from "@/utils/type_checks";

/**
 * Filters data to exclude order restatements and user notifications.
 *
 * @param data - Raw data array from API
 * @returns Object containing filtered data and flag indicating if only restatements were present
 */
export const filterBlotterData = (
  data: any[]
): { filtered_data: any[]; only_restatements: boolean } => {
  const filtered_data: any[] = [];
  let only_restatements = false;
  let non_restatement_count = 0;

  // Iterate through the data and filter out order restatements and user notifications
  for (const rpt of data) {
    if (!isOrderRestatement(rpt)) {
      non_restatement_count++;

      if (!isUserNotification(rpt)) {
        filtered_data.push(rpt);
      }
    }
  }

  // If no non-restatement rows are present, set the only_restatements flag to true
  if (non_restatement_count === 0) {
    only_restatements = true;
  }

  return { filtered_data, only_restatements };
};
